import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "as-content-page" }
const _hoisted_2 = {
  key: 0,
  class: "as-py-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_tags = _resolveComponent("filter-tags")!
  const _component_MatchsSkeleton = _resolveComponent("MatchsSkeleton")!
  const _component_MatcheList = _resolveComponent("MatcheList")!
  const _component_NoData = _resolveComponent("NoData")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_filter_tags, {
      tags: _ctx.tags,
      leagues: _ctx.leagues,
      sortBy: _ctx.sortBy,
      filter: _ctx.filter,
      onChangeTag: _cache[0] || (_cache[0] = (newVal) => _ctx.changeTag(newVal)),
      onChangeLeague: _cache[1] || (_cache[1] = (newVal) => _ctx.changeLeague(newVal)),
      onSorByTime: _cache[2] || (_cache[2] = (newVal) => _ctx.sorByTime(newVal))
    }, null, 8, ["tags", "leagues", "sortBy", "filter"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MatchsSkeleton)
        ]))
      : (_ctx.competitions.length > 0)
        ? (_openBlock(), _createBlock(_component_MatcheList, {
            key: 1,
            competitions: _ctx.competitions,
            filter: _ctx.filter,
            competitionType: _ctx.competitionType,
            matchLives: _ctx.matchLives
          }, null, 8, ["competitions", "filter", "competitionType", "matchLives"]))
        : (_openBlock(), _createBlock(_component_NoData, { key: 2 }))
  ]))
}